import objFactory from "_src/engine/factories/object";
import FrameBuffer from "_src/engine/framebuffer";
import primitiveFactory from "_src/engine/factories/primitive";
import {attachmentId, primitiveType} from "_src/engine/constants";

import Pass from "_src/render_graph/pass";
import WireframeShader from "_src/shaders/wireframe/wireframe";
import config from "_src/config";

export default class WireframePass extends Pass {

  constructor(attachmentsStorage, camera) {

    super(attachmentsStorage);

    this.init(camera);

  }

  init(camera) {
    const mainScene = this._addScene(camera);
    const leftSplitCompareScene = this._addScene(camera);
    const rightSplitCompareScene = this._addScene(camera);

    mainScene.clearedColor = false;
    mainScene.clearedDepth = false;
    mainScene.clearedStencil = false;

    leftSplitCompareScene.clearedColor = false;
    leftSplitCompareScene.clearedDepth = false;
    leftSplitCompareScene.clearedStencil = false;

    rightSplitCompareScene.clearedColor = false;
    rightSplitCompareScene.clearedDepth = false;
    rightSplitCompareScene.clearedStencil = false;

    const shader = new WireframeShader({transparent : true, depthTest: false});
    shader.setColor(config.outlineColor.r, config.outlineColor.g, config.outlineColor.b);

    const screenQuad = primitiveFactory.create(primitiveType.SCREEN_QUAD);

    const mainScreenPlane = objFactory.createDrawable(shader);
    mainScreenPlane.addGeometryChunk(screenQuad);
    const leftCompareScreenPlane = objFactory.createDrawable(shader);
    leftCompareScreenPlane.addGeometryChunk(screenQuad);
    const rightCompareScreenPlane = objFactory.createDrawable(shader);
    rightCompareScreenPlane.addGeometryChunk(screenQuad);

    mainScene.add(mainScreenPlane);
    leftSplitCompareScene.add(leftCompareScreenPlane);
    rightSplitCompareScene.add(rightCompareScreenPlane);

    leftSplitCompareScene.setEnabled(false);
    rightSplitCompareScene.setEnabled(false);
  }

  update() {
    if (!this.enabled) return;

    const mainScene = this.getScenes()[0];
    const leftSplitCompareScene = this.getScenes()[1];
    const rightSplitCompareScene = this.getScenes()[2];

    const {mainFB, leftCompareFB, rightCompareFB} = this.initFramebuffer();

    mainScene.setFramebuffer(mainFB);
    leftSplitCompareScene.setFramebuffer(leftCompareFB);
    rightSplitCompareScene.setFramebuffer(rightCompareFB);
  }

  initFramebuffer() {
    const mainScene = this.getScenes()[0];
    const leftSplitCompareScene = this.getScenes()[1];
    const rightSplitCompareScene = this.getScenes()[2];

    const workspaceColor = this.attachmentsStorage[attachmentId.BASE_COLOR_TEXTURE];
    const leftSplitCompareColor = this.attachmentsStorage[attachmentId.COMPARE_LEFT_TEXTURE];
    const rightSplitCompareColor = this.attachmentsStorage[attachmentId.COMPARE_RIGHT_TEXTURE];

    const primitiveIDColor = this.attachmentsStorage[attachmentId.TRIANGLE_ID_TEXTURE];
    const leftSplitIDColor = this.attachmentsStorage[attachmentId.COMPARE_LEFT_TRIANGLE_ID_TEXTURE];
    const rightSplitIDColor = this.attachmentsStorage[attachmentId.COMPARE_RIGHT_TRIANGLE_ID_TEXTURE];

    let mainAttachments = null;
    let leftCompareAttachments = null;
    let rightCompareAttachments = null;

    const splitCompareEnabled = Boolean(leftSplitCompareColor || rightSplitCompareColor);
    if (splitCompareEnabled) {
      const leftCompareScreenPlane = this.getScreenQuad(leftSplitCompareScene);
      leftCompareScreenPlane.setTexture(leftSplitIDColor, 0);
      leftCompareAttachments = [leftSplitCompareColor];

      const rightCompareScreenPlane = this.getScreenQuad(rightSplitCompareScene);
      rightCompareScreenPlane.setTexture(rightSplitIDColor, 0);
      rightCompareAttachments = [rightSplitCompareColor];
    } else {
      const mainScreenPlane = this.getScreenQuad(mainScene);
      mainScreenPlane.setTexture(primitiveIDColor, 0);
      mainAttachments = [workspaceColor];
    }

    const mainFB = new FrameBuffer(mainAttachments, null);
    const leftCompareFB = new FrameBuffer(leftCompareAttachments, null);
    const rightCompareFB = new FrameBuffer(rightCompareAttachments, null);

    return {mainFB, leftCompareFB, rightCompareFB};
  }

}
